export default __webpack_public_path__ + "static/media/image05.63ea0801.jpg";